import { CheckCircleIcon } from '@mm/icons';
import classNames from 'classnames';
import React from 'react';
import './Stepper.pcss';

type Step = {
  label: string;
};

type Props = {
  className?: string;
  children?: string | JSX.Element | JSX.Element[];
  steps: Step[];
  activeIdx?: number;
  markFormerComplete?: boolean;
  onClick?: (idx: number) => void;
};

export const Stepper = ({
  className,
  steps,
  activeIdx,
  markFormerComplete,
  onClick = () => {},
}: Props) => {
  return (
    <div className={classNames('c-stepper', className)}>
      <div className="c-stepper__steps">
        {steps.map((step, idx) => (
          <div
            onClick={() => onClick(idx)}
            key={step.label}
            className={classNames('c-stepper__step', {
              'c-stepper__step--complete':
                markFormerComplete &&
                activeIdx !== undefined &&
                idx < activeIdx,
              'c-stepper__step--active':
                activeIdx !== undefined && idx === activeIdx,
            })}
          >
            <CheckCircleIcon className="c-stepper__complete-icon" />

            <div className="c-stepper__step-label">{step.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
